import BASEAPI from '@/api/dataBase.js';
import { getUserCompanyList } from '@/common/js/util';

export const searchColumns = (ctx) => {
  return [
    {
      prop: 'nicheCompanyNo',
      name: '公司',
      type: 'select',
      placeholder: '请选择公司',
      options: getUserCompanyList(),
      clearable: true,
      filterable: true,
      changeMethod: 'changeMethod',
      // disabled: true,
    },
    {
      prop: 'nicheDepartmentCode',
      name: '部门',
      type: 'select',
      options: ctx.departList,
      clearable: true,
      filterable: true,
      disabled: !ctx.queryData.nicheCompanyNo,
    },
    {
      name: '招商编号',
      prop: 'nicheNo',
      type: 'input',
    },
    {
      prop: 'customerName',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'customer',
      isMultiple: true,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
        // partnerTypes: 'HZHB03,HZHB01',
      },
    },
    {
      name: '合同状态',
      type: 'dict',
      dictType: 'PROPERTY-CONTRACT-STATUS',
      placeholder: '全部状态',
      prop: 'relatedContractStatus',
    },
    {
      name: '合同编号',
      prop: 'relatedContractNo',
      type: 'input',
    },
    {
      name: '招商状态',
      prop: 'nicheStatus',
      type: 'dict',
      placeholder: '全部状态',
      dictType: 'PROPERTY-MERCHANT-STATUS',
    },
    {
      name: '入驻状态',
      prop: 'entryStatus',
      type: 'dict',
      placeholder: '全部状态',
      dictType: 'PROPERTY-MERCHANTS-ENTRY-STATUS',
    },
    {
      name: '创建人',
      prop: 'createPersonName',
      type: 'input',
    },
    {
      prop: 'gmtCreateStart',
      name: '创建时间',
      type: 'startDaterangePicker',
    },
    {
      prop: 'gmtCreateEnd',
      name: '~',
      type: 'endDaterangePicker',
    },
  ];
};

export const entryDetailCells = () => {
  return [
    {
      prop: 'nicheNo',
      name: '招商编号',
      type: 'input',
      placeholder: '自动填写',
      span: 12,
      disabled: true,
    },
    {
      prop: 'customerName',
      type: 'input',
      name: '客户名称',
      placeholder: '自动填写',
      span: 12,
      disabled: true,
    },
    {
      prop: 'relatedContractNo',
      name: '合同编号',
      type: 'input',
      placeholder: '自动填写',
      span: 12,
      disabled: true,
    },
    {
      prop: 'relatedContractStatus',
      name: '合同状态',
      type: 'ajaxSelect',
      apiUrl: BASEAPI.DIC_CREDIT_API,
      apiData: { dictType: 'PROPERTY-CONTRACT-STATUS' },
      placeholder: '自动填写',
      span: 12,
      disabled: true,
    },
    {
      prop: 'leaseContractSpace',
      name: '租赁空间',
      type: 'input',
      span: 12,
      placeholder: '自动填写',
      disabled: true,
    },
    {
      prop: 'leaseSpaceArea',
      name: '租赁面积',
      type: 'inputNumber',
      placeholder: '自动填写',
      span: 12,
      precision: 2,
      disabled: true,
    },
    {
      prop: 'leaseDuration',
      name: '租赁期限',
      type: 'input',
      placeholder: '自动填写',
      span: 12,
      disabled: true,
    },
    {
      prop: 'leaseRentAmount',
      name: '租金',
      type: 'inputNumber',
      placeholder: '自动填写',
      precision: 2,
      span: 12,
      disabled: true,
    },
    {
      prop: 'entryDate',
      name: '入驻日期',
      type: 'date',
      span: 12,
    },
    {
      prop: 'merchantContactPerson',
      name: '联系人',
      type: 'input',
      maxlength: 10,
      span: 12,
    },
    {
      prop: 'merchantContactPhone',
      name: '联系电话',
      type: 'inputNumber',
      maxlength: 20,
      span: 12,
    },
  ];
};

export const defaultTableColumns = () => {
  return [
    {
      field: 'nicheNo',
      title: '招商编号',
      width: '140',
    },
    {
      field: 'nicheCompanyName',
      title: '公司',
      width: '140',
    },
    {
      field: 'nicheDepartmentName',
      title: '部门',
      width: '140',
    },
    {
      field: 'customerName', //
      title: '客户名称',
      width: '140',
    },
    {
      field: 'nicheStatus',
      title: '招商状态',
      width: '140',
    },
    {
      field: 'relatedContractNo',
      title: '关联合同号',
      width: '140',
    },
    {
      field: 'relatedContractStatus',
      title: '合同状态',
      width: '140',
    },
    {
      field: 'entryStatus',
      title: '入驻状态',
      width: '140',
    },
    {
      field: 'createPersonName',
      title: '创建人',
      width: '140',
    },
    {
      field: 'gmtCreate',
      title: '创建时间',
      width: '140',
    },
  ];
};
